var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "professional-content" }, [
    _c("span", { staticClass: "header" }, [
      _vm._v("Profissional Selecionado(a)")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "professional-info" }, [
      _c(
        "div",
        {
          staticClass: "left",
          class: { "left-fullwidth": !_vm.scheduleConfirmed }
        },
        [
          _c("img", {
            staticClass: "profile-picture",
            attrs: { src: _vm._f("profilePicture")(_vm.professional) }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "infos" }, [
            _c("div", { staticClass: "name" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("shorterFullName")(_vm.professional)))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rating" },
                [
                  _c("Star"),
                  _vm._v(" "),
                  _c("span", { staticClass: "rating-number" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm._f("rating")(_vm.professional)) +
                        " "
                    ),
                    _vm.professional.total_feedbacks_count > 3
                      ? _c("span", { staticClass: "feedback-count" }, [
                          _vm._v(
                            "(" +
                              _vm._s(_vm._f("feedbacks")(_vm.professional)) +
                              ")"
                          )
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "orders-count" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.totalOrders() > 0
                      ? _vm.totalOrders() + " limpezas  realizadas"
                      : "Novo(a) profissional"
                  ) +
                  "\n        "
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.scheduleConfirmed && !_vm.orderOfferEnable
        ? _c(
            "div",
            {
              staticClass: "right",
              on: { click: _vm.unsetScheduleConfirmation }
            },
            [
              _c("img", {
                staticClass: "calendar",
                attrs: { src: "/static/calendar-edit-outlined.svg" }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("agenda")])
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81960462", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81960462","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/Professional/Index.vue
// module id = null
// module chunks = 